var map = {
	"./0910_1.jpg": "e990",
	"./0910_2.jpg": "7604",
	"./0910b_1.jpg": "82e7",
	"./0910b_2.jpg": "a284",
	"./0910b_cover.jpg": "2420",
	"./0910c_1.jpg": "41e2",
	"./0910d_1.jpg": "1cd2",
	"./0910d_2.jpg": "05af",
	"./0910e_1.jpg": "841c",
	"./0910e_2.jpg": "845e",
	"./0910f_1.jpg": "dbed",
	"./0910f_2.jpg": "4578",
	"./0910f_cover.jpg": "6927",
	"./0911_cover.jpg": "6417",
	"./0913_1.jpg": "daf1",
	"./0913_cover.jpg": "e995",
	"./0922_1.jpg": "a0fc",
	"./0922_2.jpg": "4ed1",
	"./0922_cover.jpg": "3ebb",
	"./1009a_1.jpg": "2508",
	"./1009a_2.jpg": "4f46",
	"./1009a_3.jpg": "26ab",
	"./1009b_cover.jpg": "f24d",
	"./1009c_1.jpg": "b41b",
	"./1009d_1.jpg": "39cc",
	"./1009e_1.jpg": "aed7",
	"./1013_cover.jpg": "b788",
	"./1020_1.jpg": "1a5a",
	"./1020_2.jpg": "c76b",
	"./1020_3.jpg": "fd00",
	"./1026_cover.jpg": "8976",
	"./1106a_1.jpg": "218b",
	"./1106a_2.jpg": "18ce",
	"./1106a_3.jpg": "ae90",
	"./1106a_4.jpg": "2062",
	"./1106a_5.jpg": "57f8",
	"./1106a_6.jpg": "dd4f",
	"./1106b_1.jpg": "b489",
	"./1106c_1.jpg": "f87b",
	"./1106d_1.jpg": "0e51",
	"./1106e_1.jpg": "01f7",
	"./1106e_2.jpg": "3f46",
	"./1212a_1.jpg": "fabb",
	"./1212a_2.jpg": "7837",
	"./1212a_3.jpg": "953c",
	"./1212b_1.jpg": "5937",
	"./1212b_2.jpg": "cffe",
	"./1212b_3.jpg": "50a8",
	"./1212c_1.jpg": "4bff",
	"./1212c_2.jpg": "780b",
	"./1212c_3.jpg": "4554",
	"./1212d_1.jpg": "4ffd",
	"./1212e_1.jpg": "1e11",
	"./1212e_2.jpg": "d5ec",
	"./1212e_3.jpg": "c4c4",
	"./2023-01-09a_1.jpg": "88dd",
	"./2023-01-09a_2.jpg": "755f",
	"./2023-01-09a_3.jpg": "1ce0",
	"./2023-01-09b_1.jpg": "fb62",
	"./2023-01-09c_1.jpg": "8311",
	"./2023-01-09c_2.jpg": "a76d",
	"./2023-01-09d_1.jpg": "9ce1",
	"./2023-01-09d_2.jpg": "bc8b",
	"./2023-01-09d_3.jpg": "6c5e",
	"./2023-01-09e_1.jpg": "b041",
	"./2023-01-09e_2.jpg": "256c",
	"./2023-01-09e_3.jpg": "5ea6",
	"./2023-01-09e_4.jpg": "bdc8",
	"./2023-04-25 21.29.34.jpg": "dda9",
	"./2023-04-25 21.30.12.jpg": "8d6f",
	"./20230628_185819.jpeg": "3bc2",
	"./20231123_185123-2.jpg": "c62f",
	"./20231123_194643-2.jpg": "2ecf",
	"./2024-02-13a_1.jpg": "ea40",
	"./2024-02-13a_2.jpg": "667d",
	"./2024-02-13a_3.jpg": "2268",
	"./2024-02-13b_1.jpg": "6797",
	"./2024-02-13b_2.jpg": "25a3",
	"./2024-02-13c_1.jpg": "a923",
	"./2024-02-13c_2.jpg": "066e",
	"./2024-02-13c_3.jpg": "f416",
	"./2024-02-13d_1.jpg": "f485",
	"./2024-02-13d_2.jpg": "efaf",
	"./2024-02-13e_1.jpg": "cf8f",
	"./2024-02-13e_2.jpg": "c300",
	"./2024-02-13e_3.jpg": "b7fd",
	"./2024-02-13e_4.jpg": "0e78",
	"./2024-02-13f_1.png": "4044",
	"./2024-02-13f_2.jpg": "f55e",
	"./2024-02-13f_3.jpg": "6adb",
	"./2024-03-08a_1.jpg": "e9cf",
	"./2024-03-08a_2.jpg": "4f98",
	"./2024-03-08a_3.jpg": "24fa",
	"./2024-03-08b_1.jpg": "2e10",
	"./2024-03-08b_2.jpg": "27d4",
	"./2024-03-08b_3.jpg": "41a9",
	"./2024-03-19a_1.jpg": "3709",
	"./2024-03-19a_2.jpg": "79a0",
	"./2024-03-19a_3.jpg": "b9b6",
	"./2024-03-19b_1.jpg": "da54",
	"./2024-03-19b_2.jpg": "3a3e",
	"./2024-03-19b_3.jpg": "63f0",
	"./2024-03-19c_1.jpg": "9132",
	"./2024-03-19d_1.jpg": "58a5",
	"./2024-03-19e_1.jpg": "383d",
	"./2024-03-19e_2.jpg": "4001",
	"./2024-03-19e_3.jpg": "58af",
	"./2024-03-19e_4.jpg": "4fa8",
	"./2024-03-19f_1.jpg": "60aa",
	"./2024-03-19f_2.jpg": "2b1f",
	"./2024-07-01a_1.jpg": "584e",
	"./2024-07-01a_2.jpg": "f103",
	"./2024-07-01a_3.jpg": "d81f",
	"./2024-07-01a_4.jpg": "0930",
	"./2024-07-01a_5.jpg": "6ab0",
	"./2024-07-01b_1.jpg": "d8a8",
	"./2024-07-01c_1.jpg": "fe2f",
	"./2024-07-01c_2.jpg": "6b0e",
	"./2024-07-01c_3.jpg": "0ab5",
	"./2024-07-01c_4.jpg": "320d",
	"./2024-07-01c_5.jpg": "4227",
	"./2024-07-01c_6.jpg": "4981",
	"./2024-07-01c_7.jpg": "44fc",
	"./2024-07-01c_8.jpg": "93bb",
	"./2024-07-01d_1.jpg": "7d92",
	"./2024-07-01d_2.jpg": "3e7f",
	"./2024-07-01d_3.jpg": "3d7f",
	"./2024-07-01d_4.jpg": "9b72",
	"./2024-08-29a_1.jpg": "beb0",
	"./2024-08-29b_1.jpg": "831b",
	"./2024-08-29b_2.jpg": "834f",
	"./2024-08-29b_3.jpg": "8d79",
	"./2024-08-29c_1.jpg": "062d",
	"./2024-08-29c_2.jpg": "1f2b",
	"./2024-08-29c_3.jpg": "9783",
	"./2024-08-29c_4.jpg": "3a08",
	"./2024-08-29c_5.jpg": "2958",
	"./2024-08-29d_1.jpg": "581a",
	"./2024-08-29d_2.jpg": "866b",
	"./2024-08-29d_3.jpg": "c586",
	"./2024-09-19a_1.jpg": "6054",
	"./2024-09-19b_1.jpg": "1bf6",
	"./2024-09-19b_2.jpg": "e710",
	"./2024-09-19b_3.jpg": "f242",
	"./2024-09-19b_4.jpg": "0629",
	"./2024-09-19b_5.jpg": "8168",
	"./2024-09-19b_6.jpg": "3ef2",
	"./2024-09-19c_1.jpg": "b74d",
	"./2024-09-19c_2.jpg": "1c20",
	"./2024-09-19c_3.jpg": "8d24",
	"./2024-09-19c_4.jpg": "bed2",
	"./2024-09-19d_1.jpg": "9e10",
	"./2024-09-19d_2.jpg": "25c6",
	"./2024-09-19d_3.jpg": "9ac5",
	"./2024-09-19d_4.jpg": "309d",
	"./2024-09-19d_5.jpg": "d83b",
	"./2024-09-19e_1.jpg": "81a5",
	"./2024-09-19e_2.jpg": "8d13",
	"./2024-10-16a_1.jpg": "9f51",
	"./2024-10-16a_2.jpg": "6ff8",
	"./2024-10-16a_3.jpg": "4237",
	"./2024-10-16b_1.jpg": "a081",
	"./2024-10-16b_2.jpg": "a6f0",
	"./2024-10-16b_3.jpg": "41b3",
	"./2024-10-16c_1.jpg": "2de3",
	"./2024-10-16c_2.jpg": "2fc9",
	"./2024-10-16c_3.jpg": "f60f",
	"./2024-10-16d_1.jpg": "fe58",
	"./2024-10-16d_2.jpg": "f13e",
	"./2024-10-16d_3.jpg": "d771",
	"./2024-10-16e_1.jpg": "e401",
	"./2024-10-16f_1.jpg": "0f8e",
	"./2024-10-16f_2.jpg": "90fd",
	"./2024-10-16f_3.jpg": "262a",
	"./2024-10-16f_4.jpg": "9ff2",
	"./2024-10-16f_5.jpg": "c243",
	"./2024-11-15a_1.jpg": "bd5c",
	"./2024-11-15a_2.jpg": "af10",
	"./2024-11-15a_3.jpg": "3789",
	"./2024-11-15b_1.jpg": "ee4c",
	"./2024-11-15b_2.jpg": "ab8e",
	"./2024-11-15b_3.jpg": "cd69",
	"./2024-11-15c_1.jpg": "a948",
	"./2024-11-15c_2.jpg": "5c31",
	"./2024-11-15c_3.jpg": "479d",
	"./2024-11-15c_4.jpg": "69b1",
	"./2024-11-15d_1.jpg": "f1d5",
	"./2024-11-15d_2.jpg": "7472",
	"./2024-11-15d_3.jpg": "bd6a",
	"./2024-12-12a_1.jpg": "9795",
	"./2024-12-12a_2.jpg": "e91a",
	"./2024-12-12a_3.jpg": "2937",
	"./2024-12-12a_4.jpg": "7a71",
	"./2024-12-12b_1.jpg": "12c4",
	"./2024-12-12b_2.jpg": "3a7c",
	"./2024-12-12b_3.jpg": "0916",
	"./2024-12-12c_1.jpg": "2138",
	"./2024-12-12c_2.jpg": "9df9",
	"./2024-12-12c_3.jpg": "9e9a",
	"./2024-12-12d_1.jpg": "f901",
	"./2024-12-12d_2.jpg": "992e6",
	"./2024-12-12d_3.jpg": "510c",
	"./2025-01-09a_1.jpg": "b270",
	"./2025-01-09a_2.jpg": "8fde",
	"./2025-01-09a_3.jpg": "f937",
	"./2025-01-09b_1.jpg": "1534",
	"./2025-01-09b_2.jpg": "23e6",
	"./2025-01-09b_3.jpg": "af7d",
	"./2025-01-09c_1.jpg": "cbb6",
	"./2025-01-09d_1.jpg": "76dc",
	"./2025-01-09d_2.jpg": "b2a5",
	"./2025-01-09d_3.jpg": "55af",
	"./2025-02-13a_1.jpg": "83b2",
	"./2025-02-13a_2.jpg": "9f871",
	"./2025-02-13b_1.jpg": "6c95",
	"./2025-02-13b_2.jpg": "80b8",
	"./2025-02-13c_1.jpg": "938a",
	"./2025-02-13c_2.jpg": "78a0",
	"./2025-02-13c_3.jpg": "b332",
	"./2025-02-13c_4.png": "0089",
	"./2025-02-13d_1.jpg": "8204",
	"./2025-02-13d_2.jpg": "70b4",
	"./2025-02-13d_3.jpg": "be51",
	"./2025-02-13e_1.jpg": "f997",
	"./2025-03-12a_1.jpg": "cd23",
	"./2025-03-12b_1.jpg": "cfb8",
	"./2025-03-12b_2.jpg": "b6b6",
	"./2025-03-12b_3.jpg": "ff15",
	"./2025-03-12b_4.jpg": "440e",
	"./2025-03-12c_1.jpg": "f1c8",
	"./2025-03-12c_2.jpg": "4c56",
	"./2025-03-12c_3.jpg": "7d3f",
	"./2025-03-12c_4.jpg": "d453",
	"./2025-03-12d_1.jpg": "f7d8",
	"./2025-03-12d_2.jpg": "b495",
	"./2025-03-12e_1.jpg": "b7ea",
	"./2025-03-12e_2.jpg": "c79a",
	"./2025-03-12e_3.jpg": "0eab",
	"./2025-03-12e_4.jpg": "5cf9",
	"./2025-04-12a_1.jpg": "e04a",
	"./2025-04-12a_2.jpg": "80d8",
	"./2025-04-12a_3.jpg": "befa",
	"./2025-04-12b_1.jpg": "f0e7",
	"./2025-04-12b_2.jpg": "2bfb",
	"./2025-04-12b_3.jpg": "1bf7",
	"./2025-04-12c_1.jpg": "fe95",
	"./2025-04-12c_2.jpg": "58d4",
	"./2025-04-12c_3.jpg": "c1d6",
	"./2025-05-09a_1.jpg": "123f",
	"./2025-05-09a_2.jpg": "77b2",
	"./2025-05-09a_3.jpg": "3f52",
	"./2025-05-09a_4.jpg": "f04f",
	"./2025-05-09a_5.jpg": "bd8d",
	"./2025-05-09a_6.jpg": "0ed2",
	"./2025-05-09a_7.jpg": "8664",
	"./2025-05-09a_8.jpg": "31bc",
	"./2025-05-09a_9.jpg": "48a0",
	"./2025-05-09b_1.jpg": "49c0",
	"./2025-05-09b_2.jpg": "697c",
	"./2025-05-09b_3.jpg": "78a7",
	"./2025-05-09c_1.jpg": "a373",
	"./2025-05-09c_2.jpg": "4e1f",
	"./2025-05-09c_3.jpg": "39e5",
	"./2025-05-09c_4.jpg": "2837",
	"./2025-05-09c_5.jpg": "5fe5",
	"./2025-05-09c_6.jpg": "111a",
	"./2025-05-09c_7.jpg": "6bf3",
	"./2025-05-09c_8.jpg": "9d5f",
	"./2025-05-09d_1.jpg": "50cb",
	"./2025-05-09d_2.jpg": "42a3",
	"./2025-05-09d_3.jpg": "8917",
	"./2025-06-11a_1.jpg": "91e7",
	"./2025-06-11a_2.jpg": "217e",
	"./2025-06-11a_3.jpg": "9286",
	"./2025-06-11a_4.jpg": "af7d8",
	"./2025-06-11a_5.jpg": "82a2",
	"./2025-06-11a_6.jpg": "2733",
	"./2025-06-11a_7.jpg": "47bf",
	"./2025-06-11b_1.jpg": "2722",
	"./2025-06-11b_2.jpg": "5eef",
	"./2025-06-11b_3.jpg": "bbcd",
	"./2025-06-11b_4.jpg": "a80b",
	"./2025-06-11c_1.jpg": "9e25",
	"./2025-06-11c_2.jpg": "120c",
	"./2025-06-11c_3.jpg": "9e24",
	"./2025-06-11d_1.jpg": "9e3d",
	"./2025-06-11d_2.jpg": "ae0f",
	"./2025-06-11d_3.jpg": "6fd2",
	"./2025-06-11d_4.jpg": "3f37",
	"./2025-07-21a_1.jpg": "d5e1",
	"./2025-07-21a_10.jpg": "6471",
	"./2025-07-21a_11.jpg": "b541",
	"./2025-07-21a_12.jpg": "0c1f",
	"./2025-07-21a_2.jpg": "420c",
	"./2025-07-21a_3.jpg": "34ac",
	"./2025-07-21a_4.jpg": "5ee1",
	"./2025-07-21a_5.jpg": "a31a",
	"./2025-07-21a_6.jpg": "f1dc",
	"./2025-07-21a_7.jpg": "2fb9",
	"./2025-07-21a_8.jpg": "20f0",
	"./2025-07-21a_9.jpg": "172e",
	"./2025-07-21b_1.jpg": "f141",
	"./2025-07-21b_2.jpg": "7e46",
	"./2025-07-21b_3.jpg": "62f5",
	"./2025-07-21b_4.jpg": "a027",
	"./2025-07-21b_5.jpg": "242d",
	"./2025-07-21b_6.jpg": "0518",
	"./2025-07-21c_1.jpg": "32dc",
	"./2025-07-21c_2.jpg": "928e",
	"./2025-07-21c_3.jpg": "66b0",
	"./2025-07-21d_1.jpg": "bddc",
	"./2025-07-21d_2.jpg": "02da",
	"./2025-08-16b_1.jpg": "2c52",
	"./2025-08-16b_2.jpg": "9b21",
	"./2025-08-16b_3.jpg": "87bb",
	"./2025-08-16b_4.jpg": "32ad",
	"./2025-08-16b_5.jpg": "5ed6",
	"./2025-08-16b_6.jpg": "7dfc",
	"./2025-08-16b_7.jpg": "ae2e",
	"./2025-08-16b_8.jpg": "a07e",
	"./2025-08-16c_1.jpg": "5e02",
	"./2025-08-16c_2.jpg": "2a6d",
	"./2025-08-16c_3.jpg": "38e7",
	"./2025-08-16c_4.jpg": "c426",
	"./2025-08-16c_5.jpg": "1fd7",
	"./2025-08-16c_6.jpg": "accb",
	"./2025-08-16c_7.jpg": "62b7",
	"./2025-08-16d_1.jpg": "02bf",
	"./2025-08-16d_2.jpg": "805f",
	"./2025-08-16d_3.jpg": "4d4a",
	"./2025-08-16e_1.jpg": "98c6",
	"./2025-08-16e_2.jpg": "2d48",
	"./2025-08-16e_3.jpg": "ad20",
	"./2025-09-19a_1.jpg": "2381",
	"./2025-09-19a_2.jpg": "80ca",
	"./2025-09-19b_1.jpg": "62cf",
	"./2025-09-19b_2.jpg": "94c4",
	"./2025-09-19c_1.jpg": "199e",
	"./2025-09-19c_2.jpg": "37ea",
	"./2025-09-19c_3.jpg": "4ab3",
	"./2025-09-19c_4.jpg": "e993",
	"./2025-09-19d_1.jpg": "210f",
	"./2025-09-19d_2.jpg": "5232",
	"./2025-09-19d_3.jpg": "01c4",
	"./2025-09-19d_4.jpg": "845f",
	"./2025-09-19d_5.jpg": "70e6",
	"./2025-09-19d_6.jpg": "87e8",
	"./2025-09-19d_7.jpg": "83d9",
	"./2025-09-19e_1.jpg": "0bde",
	"./2025-09-19e_2.jpg": "2873",
	"./2025-09-19e_3.jpg": "72b9",
	"./2025-10-15a_1.jpg": "1742",
	"./2025-10-15a_2.jpg": "4cdb",
	"./2025-10-15a_3.jpg": "5bd8",
	"./2025-10-15a_4.jpg": "2a64",
	"./2025-10-15a_5.jpg": "7741",
	"./2025-10-15a_6.jpg": "4b80",
	"./2025-10-15b_1.jpg": "73e4",
	"./2025-10-15b_2.jpg": "5d3b",
	"./2025-10-15c_1.jpg": "a1e2",
	"./2025-10-15d_1.jpg": "8067",
	"./2025-10-15d_2.jpg": "ff9f",
	"./2025-10-15d_3.jpg": "44be",
	"./2025-10-15d_4.jpg": "2e15",
	"./2025-11-17a_1.jpg": "2dec",
	"./2025-11-17a_2.jpg": "e3c6",
	"./2025-11-17b_1.jpg": "208a",
	"./2025-11-17b_2.jpg": "54c8",
	"./2025-11-17c_1.jpg": "ab07",
	"./2025-11-17c_10.jpg": "eb24",
	"./2025-11-17c_11.jpg": "77b0",
	"./2025-11-17c_12.jpg": "f084",
	"./2025-11-17c_13.jpg": "88cf",
	"./2025-11-17c_14.jpg": "77bc",
	"./2025-11-17c_15.jpg": "d452",
	"./2025-11-17c_16.jpg": "6bb3",
	"./2025-11-17c_17.jpg": "26c2",
	"./2025-11-17c_2.jpg": "f942",
	"./2025-11-17c_3.jpg": "a922",
	"./2025-11-17c_4.jpg": "17ea",
	"./2025-11-17c_5.jpg": "3244",
	"./2025-11-17c_6.jpg": "0cbe",
	"./2025-11-17c_7.jpg": "ccdc",
	"./2025-11-17c_8.jpg": "6f11",
	"./2025-11-17c_9.jpg": "191b",
	"./2025-11-17d_1.jpg": "a166",
	"./2025-11-17d_2.jpg": "79d4",
	"./2025-11-17d_3.jpg": "49ad",
	"./2025-12-20a_1.jpg": "39c1",
	"./2025-12-20a_2.gif": "5ccf",
	"./2025-12-20b_1.jpg": "76cf",
	"./2025-12-20b_2.jpg": "22a0",
	"./2025-12-20b_3.jpg": "3060",
	"./2025-12-20b_4.jpg": "db8d",
	"./2025-12-20c_1.jpg": "6909",
	"./2025-12-20c_2.jpg": "e391",
	"./2025-12-20c_3.jpg": "39cd",
	"./2025-12-20d_1.jpg": "dda3",
	"./2025-12-20e_1.jpg": "69fd",
	"./2025-12-20e_2.jpg": "0b3b",
	"./2025-12-20e_3.jpg": "be0b",
	"./2025-12-20f_1.jpg": "1a78",
	"./2025-12-20g_1.jpg": "c435",
	"./2025-12-20g_2.jpg": "2f09",
	"./2025-12-20g_3.jpg": "0f55",
	"./2025-12-20g_4.jpg": "3773",
	"./2025-12-20g_5.jpg": "17e9",
	"./2026-02-27a_1.jpg": "05f3",
	"./2026-02-27b_1.jpg": "f046",
	"./2026-02-27b_2.jpg": "7023",
	"./2026-02-27c_1.jpg": "a52d",
	"./2026-02-27c_2.jpg": "f7b1",
	"./2026-02-27d_1.jpg": "4ea9",
	"./2026-02-27d_2.jpg": "3124",
	"./2026-02-27d_3.jpg": "d7fb",
	"./2026-03-24a_1.jpg": "3f63",
	"./2026-03-24b_1.jpg": "9424",
	"./2026-03-24b_2.jpg": "8c4e",
	"./2026-03-24b_3.jpg": "6e11",
	"./2026-03-24c_1.jpg": "1af3",
	"./2026-03-24c_2.jpg": "c027",
	"./2026-03-24c_3.jpg": "2f2c",
	"./2026-03-24c_4.jpg": "c5869",
	"./2026-03-24c_5.jpg": "248a",
	"./2026-03-24c_6.jpg": "d6f7",
	"./2026-05-03a_1.jpg": "77da",
	"./2026-05-03b_1.jpg": "fdbd",
	"./2026-05-03c_1.jpg": "284b",
	"./2026-05-03c_2.jpg": "7a04",
	"./2026-05-03c_3.jpg": "3f1a",
	"./2026-09-21a_1.jpg": "669d",
	"./2026-09-21b_1.jpg": "21ff",
	"./2026-09-21c_1.jpg": "cb2a",
	"./2026-09-21c_2.jpg": "456e",
	"./2026-10-11a_1.jpg": "165e",
	"./2026-10-11a_2.jpg": "d1eb",
	"./2026-10-11a_3.jpg": "9636",
	"./2026-10-11b_1.jpg": "b4ad",
	"./2026-10-11c_1.jpg": "4ace",
	"./2026-10-11c_2.jpg": "238b",
	"./2026-10-11c_3.jpg": "3316",
	"./2026-10-11c_4.jpg": "f58f",
	"./2026-10-11d_1.jpg": "bddb",
	"./IMG_0530.jpg": "1d02",
	"./IMG_20231123_162737_069-2.jpg": "3d68",
	"./Ishmael-Beah.jpg": "52ca",
	"./PB_Afrika nap_097-2~2.jpeg": "2a1d",
	"./afrikai_aktualitasok_katonaipuccs_niger_AFP.png": "83a7",
	"./afrikai_aktualitasok_mali_referendum.jpeg": "b1d7",
	"./afrikai_aktualitasok_orosz-afrikai_csucs.jpeg": "2365",
	"./afrikai_gyogymodok.jpg": "7753",
	"./balogh_tunde.jpg": "788b",
	"./gyerektamogatas.jpg": "be20",
	"./kdori.jpg": "9e33",
	"./kdori_cover.jpg": "999e",
	"./kia.png": "06cc",
	"./konyvajanlo_2.jpg": "feed",
	"./ldorina.jpg": "d224",
	"./ldorina_cover.jpg": "5581",
	"./membranfonok.png": "f3a6",
	"./photo1673896265.jpeg": "b3a3",
	"./photo_2022-10-23_14-59-24.jpg": "cf6e",
	"./photo_2022-10-23_14-59-28.jpg": "2d73",
	"./photo_2022-10-23_14-59-31.jpg": "0405",
	"./photo_2022-10-26_22-16-55.jpg": "f908",
	"./photo_2022-10-26_22-17-01.jpg": "e12f",
	"./photo_2022-10-26_22-37-31.jpg": "b2ed",
	"./photo_2022-10-26_22-37-34.jpg": "c5f6",
	"./photo_2022-10-26_22-37-34_s.jpg": "8fe4",
	"./photo_2022-10-26_22-37-37.jpg": "307e",
	"./photo_2022-11-07_21-45-42.jpg": "38de",
	"./photo_2022-11-07_21-45-46.jpg": "225f",
	"./photo_2022-11-09_18-32-18.jpg": "2c8b",
	"./photo_2022-11-09_18-32-21.jpg": "f142",
	"./photo_2022-11-09_18-32-25.jpg": "4519",
	"./photo_2022-11-09_18-32-28.jpg": "c610",
	"./photo_2022-11-09_18-32-31.jpg": "dbde",
	"./photo_2023-04-22_07-58-00.jpg": "2747",
	"./photo_2023-04-22_07-58-29.jpg": "3413",
	"./photo_2023-04-22_07-58-37.jpg": "1089",
	"./photo_2023-04-22_08-14-38.jpg": "5ea2",
	"./photo_2023-04-22_08-15-40.jpg": "6885",
	"./photo_2023-04-27 22.02.06.jpeg": "831d",
	"./photo_2023-04-27 22.02.15.jpeg": "51d8",
	"./photo_2023-04-27 22.02.18.jpeg": "4f6f",
	"./photo_2023-04-27 22.07.47.jpeg": "c9fd",
	"./photo_2023-04-27 22.15.20.jpeg": "55b6",
	"./photo_2023-04-27 22.15.22.jpeg": "f934",
	"./photo_2023-04-27 22.17.46.jpeg": "9c8d",
	"./photo_2023-04-27 22.17.48.jpeg": "debd",
	"./photo_2023-05-16 19.14.37.jpeg": "3dec",
	"./photo_2023-05-16 19.14.40.jpeg": "416c",
	"./photo_2023-05-16 19.14.45.jpeg": "926d",
	"./photo_2023-05-16 19.14.51.jpeg": "c7c2",
	"./photo_2023-05-16 19.14.57.jpeg": "16e5",
	"./photo_2023-05-16 19.15.02.jpeg": "b6f9",
	"./photo_2023-06-04 10.54.36.jpeg": "43aa",
	"./photo_2023-06-04 10.54.47.jpeg": "8c5c",
	"./photo_2023-06-04 10.55.32.jpeg": "484c",
	"./photo_2023-06-04 10.55.35.jpeg": "fc5a",
	"./photo_2023-06-04 10.55.39.jpeg": "ebbf",
	"./photo_2023-11-19 17.43.39.jpg": "5a8f",
	"./photo_2023-11-19 17.43.54.jpg": "345e",
	"./photo_2023-11-19 17.43.56.jpg": "a825",
	"./photo_2023-11-19 17.43.57.jpg": "9cdd",
	"./photo_2023-11-19 17.43.58.jpg": "5e8f",
	"./photo_2023-11-19 17.43.59.jpg": "ceeb",
	"./photo_2023-11-19 17.44.00.jpg": "d8ec",
	"./photo_2023-11-19 17.44.01.jpg": "3bda",
	"./photo_2023-11-19 17.44.02.jpg": "11e3",
	"./photo_2023-11-19 17.44.04.jpg": "7bcc",
	"./photo_2023-11-22 13.51.23.jpg": "26a3",
	"./photo_2023-11-22 13.51.24.jpg": "93e2",
	"./photo_2023-11-22 13.51.25.jpg": "db96",
	"./photo_2023-11-22 13.51.27.jpg": "427a",
	"./photo_2023-11-22 13.51.28.jpg": "695f",
	"./photo_2023-11-22 13.51.29.jpg": "9851",
	"./photo_2023-11-22 13.51.30.jpg": "1acf",
	"./photo_2023-11-22 13.51.31.jpg": "fcb0",
	"./photo_2023-11-22 13.51.32.jpg": "a040",
	"./photo_2023-11-22 14.30.24.jpg": "8888",
	"./photo_2023-11-22 14.30.25.jpg": "019e",
	"./photo_2023-11-22 14.30.26.jpg": "ef8d",
	"./photo_2023-11-22 14.30.27.jpg": "8ac3",
	"./photo_2023-11-22 14.30.27b.jpg": "bff2",
	"./photo_2023-11-22 14.30.28.jpg": "b430",
	"./photo_2023-11-22 14.30.29.jpg": "8e32",
	"./photo_2023-11-22 14.30.30.jpg": "b587",
	"./photo_2023-11-22 14.30.30b.jpg": "b8f5",
	"./photo_2023-11-22 14.30.31.jpg": "8589",
	"./photo_2023-11-22 14.30.32.jpg": "2075",
	"./photo_2023-11-22 14.30.33.jpg": "7444",
	"./photo_2023-11-22 14.30.34.jpg": "a24b",
	"./photo_2023-11-27 11.39.43.jpg": "9ebe",
	"./photo_2023-11-27 11.39.45.jpg": "1f2a",
	"./photo_2023-11-27 11.39.46.jpg": "0424",
	"./photo_2023-11-27 11.39.47.jpg": "add1",
	"./photo_2023-11-27 11.39.48.jpg": "41c0",
	"./photo_2023-11-27 11.39.49.jpg": "21d2",
	"./photo_2023-12-01 19.34.58.jpg": "a02f",
	"./photo_2023-12-01 19.34.59.jpg": "ac03",
	"./photo_2023-12-01 19.35.01.jpg": "3f48",
	"./photo_2023-12-01 19.35.02.jpg": "5c2c",
	"./photo_2023-12-01 19.35.04.jpg": "34d6",
	"./photo_2023-12-01 19.35.05.jpg": "a8ec",
	"./photo_2023-12-01 19.35.06.jpg": "8c11",
	"./photo_2023-12-01 19.35.08.jpg": "f536",
	"./photo_2023-12-01 19.58.16.jpg": "dd02",
	"./photo_2023-12-01 19.58.17.jpg": "28a7",
	"./photo_2023-12-01 19.58.18.jpg": "35c2",
	"./photo_2023-12-01 19.58.19.jpg": "73eb",
	"./photo_2023-12-01 19.58.21.jpg": "2bf6",
	"./photo_2023-12-01 19.58.22.jpg": "0ec6",
	"./photo_2023-12-01 19.58.23.jpg": "000e",
	"./photo_2023-12-01 19.58.24.jpg": "8d77",
	"./photo_20230127_01.jpg": "2c02",
	"./poliritmika.png": "fc37",
	"./protectus.png": "c783",
	"./resdob.jpg": "28c3",
	"./rsz_20221029_borito.jpg": "b03b",
	"./rsz_img_0531.jpg": "91d7",
	"./rsz_img_0532.jpg": "2ada",
	"./rsz_img_20210505_183444.jpg": "5f02",
	"./rsz_img_20211026_173621.jpg": "19b8",
	"./rsz_img_20211107_101247.jpg": "007f",
	"./tomasovszki_reka.jpg": "c225",
	"./witch-doctor.png": "6840"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8f55";